export default "__VITE_ASSET__Cx9sWpCH__"